export default __webpack_public_path__ + "static/Vista-aerea-2e78541885d70ccbcb9137abe4127e06.jpg";